module.exports = __webpack_public_path__ + "static/media/vec-odometro.3422afcc.svg";